import { Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useContext, useState } from 'react';
import WarningModal from 'shared/lib/components/modals/warningModal';
import { useTranslation } from 'react-i18next';
import { ModalProps } from 'shared/lib/components/modals/modal';
import { MobxContext } from 'shared/lib/contexts/mobxContext';
import { AxiosError } from 'axios';
import { BackErrors } from 'shared/lib/utils/globalUtils';
import ErrorModal from 'shared/lib/components/modals/errorModal';
import { trashApi } from 'entities/trash/api/trashApi';

export type RestoreSectionModalControllerActions = {
  afterSectionRestore?: (section: { id: string; name: string }) => void;
};

export default observer(function RestoreSectionModalController({
  section,
  afterSectionRestore,
  handleClose,
}: {
  section: { id: string; name: string };
} & RestoreSectionModalControllerActions & {
    handleClose: ModalProps['handleClose'];
  }) {
  const { mobxStore } = useContext(MobxContext);
  const { t } = useTranslation();

  const [dublicateName, setDublicateName] = useState<null | string>(null);

  return (
    <>
      <WarningModal
        mainText={t('warnings.restore.sectionMain')}
        secondText={t('warnings.restore.sectionSecond')}
        continueText={t('common.restore')}
        isOpen={true}
        onCancel={handleClose}
        onContinue={async () => {
          try {
            await trashApi.restoreSection(section.id);
            afterSectionRestore && afterSectionRestore(section);
          } catch (e) {
            const err = e as AxiosError<{ detail?: string }>;
            console.error(e);

            if (
              err?.response?.status === 400 &&
              err?.response?.data?.detail === BackErrors.SectionExists
            ) {
              setDublicateName(section.name || '');
              return;
            }

            mobxStore.notificationsStore.errorMessage = t(
              'notifications.errors.default'
            );
          }
          handleClose();
        }}
      ></WarningModal>

      {dublicateName && (
        <ErrorModal
          mainText="Ошибка действия"
          isOpen={true}
          onClose={() => setDublicateName(null)}
        >
          <Typography variant="f18" sx={{ fontWeight: 300 }}>
            Невозможно восстановить раздел, так как раздел с&nbsp;именем &laquo;
            <span style={{ fontWeight: 700 }}>{dublicateName}</span>&raquo; уже
            существует
          </Typography>
        </ErrorModal>
      )}
    </>
  );
});
